import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ICustomerBillersInfo } from '../../../liabilities/models/model';
import { Crisp } from 'crisp-sdk-web';

@Component({
standalone: false,
  selector: 'app-credit-card-info-dialog',
  styleUrls: ['./credit-card-info-dialog.component.scss'],
  templateUrl: './credit-card-info-dialog.component.html',
})
export class CreditCardInfoDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public customerBillersInfo: ICustomerBillersInfo) {}

  public openChatWithPreparedMessage(): void {
    const message =
      `Cześć, proszę o zweryfikowanie dostawcy ${this.customerBillersInfo.billers}.` +
      'W kolejnej wiadomości przesyłam opis świadczonej przez dostawcę usługi oraz wystawiony przez niego dokument z' +
      'widocznym numerem rachunku.';

    if (typeof Intercom !== 'undefined') {
      Intercom('showNewMessage', message);
    }

    if (window['$crisp']) {
      Crisp.chat.open();
      Crisp.message.send('text', message);
    }
  }
}
